import { getSettingsGenericError } from './chunk-TDNRUBPG.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import * as yup from 'yup';

var usersBaseSchema = yup.object().shape({
  posName: yup.string().trim().required(
    JSON.stringify(
      getSettingsGenericError({
        key: "posName",
        id: "posName",
        message: i18n_config_default.t("validations.posNameRequired"),
        section: "basic" /* BASIC */
      })
    )
  ),
  pin: yup.string().trim().required(
    JSON.stringify(
      getSettingsGenericError({
        key: "pin",
        id: "pin",
        message: i18n_config_default.t("validations.invalidPin"),
        section: "basic" /* BASIC */
      })
    )
  ).min(
    4,
    getSettingsGenericError({
      key: "pin",
      id: "pin",
      message: i18n_config_default.t("validations.invalidPin"),
      section: "basic" /* BASIC */
    })
  ),
  firstName: yup.string().trim().required(
    JSON.stringify(
      getSettingsGenericError({
        key: "firstName",
        id: "firstName",
        message: i18n_config_default.t("validations.firstNameRequired"),
        section: "basic" /* BASIC */
      })
    )
  ),
  lastName: yup.string().trim().required(
    JSON.stringify(
      getSettingsGenericError({
        key: "lastName",
        id: "lastName",
        message: i18n_config_default.t("validations.lastNameRequired"),
        section: "basic" /* BASIC */
      })
    )
  ),
  phoneNumber: yup.string().trim().required(
    JSON.stringify(
      getSettingsGenericError({
        key: "phoneNumber",
        id: "phoneNumber",
        message: i18n_config_default.t("validations.phoneNumberRequired"),
        section: "basic" /* BASIC */
      })
    )
  ).min(
    10,
    JSON.stringify(
      getSettingsGenericError({
        key: "phoneNumber",
        id: "phoneNumber",
        message: i18n_config_default.t("validations.invalidPhoneNumber"),
        section: "basic" /* BASIC */
      })
    )
  )
});
var usersLocationSchema = usersBaseSchema.concat(
  yup.object().shape({
    roleIds: yup.array().min(
      1,
      JSON.stringify(
        getSettingsGenericError({
          key: "roleIds",
          id: "roleIds",
          message: i18n_config_default.t("validations.atLeast1Bucket", {
            bucketName: i18n_config_default.t("menuScreen.common.settings.roles.singular")
          }),
          section: "associations" /* ASSOCIATIONS */
        })
      )
    )
  })
);
var usersMasterSchema = usersBaseSchema.concat(
  yup.object().shape({
    locationIds: yup.array().min(
      1,
      JSON.stringify(
        getSettingsGenericError({
          key: "locationIds",
          id: "locationIds",
          message: i18n_config_default.t("validations.atLeast1Bucket", {
            bucketName: i18n_config_default.t("commonTexts.location")
          }),
          section: "associations" /* ASSOCIATIONS */
        })
      )
    )
  })
);

export { usersLocationSchema, usersMasterSchema };
